import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Map from '../../../components/mapcompo/Mapcompo'
import styles from './zonemap.module.css'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { useLocation, useNavigate } from 'react-router-dom'

const Zonemap = () => {
    const location = useLocation();
    const zoneName = location.state?.zoneName;
    const zonecoordinates = location.state?.coordinates;
    const navigate = useNavigate();
    return (
        <div className={styles.zonecontainer}>
            <div className={styles.heading}>
                <button className={styles.back} type="button" onClick={() => navigate(-1)}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <h2 className={styles.head}>
                    {zoneName ? `Zonemap for ${zoneName}` : 'Add a new zonemap'}
                </h2>

            </div>
            <div className={styles.container}>
                <Map
                    locations={[]}
                    polypoints={zonecoordinates ? zonecoordinates : []}
                    createZone={zoneName ? false : true}
                // disBorder
                />
            </div>
        </div>
    )
}

export default Zonemap